export const normalTheme = {
  primaryColor: '#002D55',
  secondaryColor: '#0079BF',
};
